/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import axiosMethods from '@/api/apiManager';
import InputField from '@/components/inputfield/InputField';
import {ADVANCE_SETUP_RESTRICTION} from '@/constants/advSetupConstant';
import {PRESSURE_ROW} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import {
  findMaxValueByRepeatType,
  findMaxDigitValueByRepeatType,
  findIncrementValueByRepeatType,
} from './business/commonFunction';
import {
  UpdateDiaphragmTimingOpen,
  UpdateDiaphragmTimingClose,
  UpdateValveTiming,
  ValidateBottlePressure,
  ValidateDiaphragmPressure,
  ValidateSourcePressure,
  UpdateSequenceType,
  UpdateTempRate,
} from './business/sequenceContent';
import CycleSetting from './components/CycleSetting';
import {GenerateSequenceSelector} from './components/SequenceTypeUpdate';
import * as PRESSURE_CONSTANT from './constant/pressureContentConstant';
import {SEQUENCE_TYPE, RUN_TIME_MODE, SEQUENCE_TYPE_ALL_ENUM} from './constant/sequenceContentConstants';
// eslint-disable-next-line import/no-cycle
import {VIEW_MODE} from './ManualProfile';

import './SequenceConfigurations.less';

const defaultSetup = (sequenceName, defaultAdvSetup) => {
  switch (sequenceName) {
    case SEQUENCE_TYPE_ALL_ENUM.PRIME.BE:
      return {
        diaphragmPressure: defaultAdvSetup.PrimeAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.PrimeAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.PrimeAdvSetup.DiaphragmTimingClose,
      };
    case SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE:
      return {
        diaphragmPressure: defaultAdvSetup.PrimeAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.PrimeAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.PrimeAdvSetup.DiaphragmTimingClose,
      };
    case SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE:
      return {
        diaphragmPressure: defaultAdvSetup.MainAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        returnValvePressure: defaultAdvSetup.MainAdvSetup.PressureAdvSetup[PRESSURE_ROW.BOTTLE],
        diaphragmTimingOpen: defaultAdvSetup.MainAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.MainAdvSetup.DiaphragmTimingClose,
      };
    case SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE:
      return {
        diaphragmPressure: defaultAdvSetup.DiafiltrationAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.DiafiltrationAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.DiafiltrationAdvSetup.DiaphragmTimingClose,
      };
    case SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE:
      return {
        diaphragmPressure: defaultAdvSetup.RecoveryAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.RecoveryAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.RecoveryAdvSetup.DiaphragmTimingClose,
      };
    case SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE:
      return {
        diaphragmPressure: defaultAdvSetup.RecoveryAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.RecoveryAdvSetup.BufferRecoveryDiaphragmTiming.FillTiming,
        diaphragmTimingClose: defaultAdvSetup.RecoveryAdvSetup.BufferRecoveryDiaphragmTiming.EmptyTiming,
      };
    case SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE:
      return {
        diaphragmPressure: defaultAdvSetup.TubeMixingAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.TubeMixingAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.TubeMixingAdvSetup.DiaphragmTimingClose,
      };
    case SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE:
      return {
        diaphragmPressure: defaultAdvSetup.RecirculateAdvSetup.PressureAdvSetup[PRESSURE_ROW.DIAPHRAGM],
        diaphragmTimingOpen: defaultAdvSetup.RecirculateAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.RecirculateAdvSetup.DiaphragmTimingClose,
      };
    default:
      return {
        diaphragmPressure: defaultAdvSetup.PrimeAdvSetup.PressureAdvSetup[2],
        diaphragmTimingOpen: defaultAdvSetup.PrimeAdvSetup.DiaphragmTimingOpen,
        diaphragmTimingClose: defaultAdvSetup.PrimeAdvSetup.DiaphragmTimingClose,
      };
  }
};

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  defaultHighPressureParam: store.setupStore.defaultHighPressureParam,
  defaultLowPressureParam: store.setupStore.defaultLowPressureParam,
  defaultHighSeqParam: store.setupStore.defaultHighSeqParam,
  defaultLowSeqParam: store.setupStore.defaultLowSeqParam,
  defaultPressureTemplate: store.setupStore.defaultPressureTemplate,
  defaultSequenceTemplate: store.setupStore.defaultSequenceTemplate,
  defaultConfigAdvSetupParams: store.setupStore.defaultConfigAdvSetupParams,
}))
class SequenceConfiguration extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sequenceConfig: PC_COMMON_FUNCTION.createNewJsonObject(this.props.sequence),
      parameterChanged: false,
      PressureControllerThreshold: [],
    };
  }

  componentDidMount() {
    this.getPressureControllerThreshold();
    this.updateTopMenuProps(this.state.sequenceConfig);
  }

  getPressureControllerThreshold = () => {
    axiosMethods
      .get(APPDATA.API.GET_PRESSURE_CONTROLER)
      .then((response) => {
        if (response.status === 200) {
          const PressureControllerThreshold = response.data;
          this.setState({
            PressureControllerThreshold,
          });
        }
      })
      .catch((error) => {
        consoleLog(`[Get PressureControllerThreshold]${error}`);
      });
  };

  updateSequenceConfig = (newSequenceConfig) => {
    this.setState({
      sequenceConfig: newSequenceConfig,
      parameterChanged: true,
    });
    this.updateTopMenuProps(newSequenceConfig);
  };

  updateTopMenuProps = (sequenceConfig) => {
    const getDefaultConfig = defaultSetup(
      sequenceConfig.Sequence,
      this.props.defaultConfigAdvSetupParams.ConfigAdvSetup,
    );
    const isSequenceEqualsDefault = this.CompareSequenceParameterWithDefault(sequenceConfig, getDefaultConfig);
    this.setState({
      parameterChanged: !isSequenceEqualsDefault,
    });
    this.props.topMenuProps({
      onClickDefault: this.discardConfig,
      disabledSecondaryButton: isSequenceEqualsDefault,
      parameterChanged: !isSequenceEqualsDefault,
    });
  };

  // eslint-disable-next-line class-methods-use-this
  CompareSequenceParameterWithDefault = (sequence, seqTemplate) => {
    const {
      SequenceParams: {Lo},
      PressureState: {PressureConfig, PressureType},
    } = sequence;

    const {diaphragmTimingOpen, diaphragmTimingClose, diaphragmPressure, returnValvePressure} = seqTemplate;

    return (
      Number(Lo.DiaphragmTimingOpen) === Number(diaphragmTimingOpen) &&
      Number(Lo.DiaphragmTimingClose) === Number(diaphragmTimingClose) &&
      PressureConfig[PressureType][PRESSURE_ROW.DIAPHRAGM] === diaphragmPressure &&
      (returnValvePressure === undefined || PressureConfig[PressureType][PRESSURE_ROW.BOTTLE] === returnValvePressure)
    );
  };

  onClickHight = (e) => {
    const props = {
      currentValue: 0,
      headerTitle: 'Default Numpad Input Title',
      minValue: 5,
      maxValue: 55,
      unit: APPDATA.UNIT.psi,
      callback: this.onChangeField,
      validatorInput: undefined,
      maxDigitAfterDecimal: APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
      info: undefined,
    };
    const TitlePopUp = 'High';
    const minValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MIN_VALUE;
    const maxValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MAX_VALUE;
    const maxDigitAfterDecimal = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].DECIMAL_PLACE_ACCURACY;
    const info = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].INFO;
    props.minValue = minValue;
    props.maxValue = maxValue;
    props.maxDigitAfterDecimal = maxDigitAfterDecimal;
    props.info = info;
    props.label = e.currentTarget.id;
    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.SOURCE_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        props.validatorInput = this.validateSourcePressureHight;
        // props.maxValue = HighPressureParam[PRESSURE_ROW.SOURCE];
        break;
      case APPDATA.FIELD_NAME.VACUUM_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = -10
        // props.maxValue = -2
        break;
      case APPDATA.FIELD_NAME.BOTTLE_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 3
        props.validatorInput = this.validateBottlePressureHight;
        props.minValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.HI.BOTTLE_PRESSURE.MIN_VALUE;
        props.maxValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.HI.BOTTLE_PRESSURE.MAX_VALUE;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 4
        props.validatorInput = this.validateDiaphragmPressureHight;
        props.minValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.HI.DIAPHRAGM_PRESSURE.MIN_VALUE;
        props.maxValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.HI.DIAPHRAGM_PRESSURE.MAX_VALUE;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 100
        // props.maxValue = 1000
        props.incrementValue = 1;
        props.unit = APPDATA.UNIT.ms;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 100
        // props.maxValue = 1000
        props.incrementValue = 1;
        props.unit = APPDATA.UNIT.ms;
        break;
      case APPDATA.FIELD_NAME.VALVE_TIMING:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 10
        // props.maxValue = 50
        props.incrementValue = 1;
        props.unit = APPDATA.UNIT.ms;
        break;
      default:
        break;
    }
    this.showNumpad(props);
  };

  onClickLow = (e) => {
    // const LowPressureparam = PC_COMMON_FUNCTION.createNewJsonObject(
    //   this.state.sequenceConfig.PressureState.PressureConfig.Lo,
    // );
    const props = {
      currentValue: 0,
      headerTitle: 'Default Numpad Input Title',
      minValue: 5,
      maxValue: 55,
      unit: APPDATA.UNIT.psi,
      callback: this.onChangeField,
      validatorInput: undefined,
      info: undefined,
    };
    const TitlePopUp = 'Low';
    const minValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MIN_VALUE;
    const maxValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MAX_VALUE;
    const maxDigitAfterDecimal = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].DECIMAL_PLACE_ACCURACY;
    const info = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].INFO;
    props.minValue = minValue;
    props.maxValue = maxValue;
    props.maxDigitAfterDecimal = maxDigitAfterDecimal;
    props.info = info;
    props.label = e.currentTarget.id;
    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.SOURCE_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        props.validatorInput = this.validateSourcePressureLow;
        // props.maxValue = LowPressureparam[PRESSURE_ROW.SOURCE];
        break;
      case APPDATA.FIELD_NAME.VACUUM_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = -10;
        // props.maxValue = -2;
        break;
      case APPDATA.FIELD_NAME.BOTTLE_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 3;
        props.validatorInput = this.validateBottlePressureLow;
        props.minValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.LOW.BOTTLE_PRESSURE.MIN_VALUE;
        props.maxValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.LOW.BOTTLE_PRESSURE.MAX_VALUE;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 4;
        props.validatorInput = this.validateDiaphragmPressureLow;
        props.minValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.LOW.DIAPHRAGM_PRESSURE.MIN_VALUE;
        props.maxValue = PRESSURE_CONSTANT.PRESSURE_PARAMETER_LIMIT.LOW.DIAPHRAGM_PRESSURE.MAX_VALUE;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 100;
        // props.maxValue = 1000;
        props.incrementValue = 1;
        props.unit = APPDATA.UNIT.ms;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 100;
        // props.maxValue = 1000;
        props.incrementValue = 1;
        props.unit = APPDATA.UNIT.ms;
        break;
      case APPDATA.FIELD_NAME.VALVE_TIMING:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = `${TitlePopUp}-${e.currentTarget.id}`;
        // props.minValue = 10;
        // props.maxValue = 50;
        props.incrementValue = 1;
        props.unit = APPDATA.UNIT.ms;
        break;
      default:
        break;
    }
    consoleLog('Show Numpad', {ADVANCE_SETUP_RESTRICTION: ADVANCE_SETUP_RESTRICTION[e.currentTarget.id], props});
    this.showNumpad(props);
  };

  validateBottlePressureHight = (e) => {
    const {sequenceConfig} = this.state;
    // const id = e.type;
    const newValue = e.value;
    const HighPressureParam = sequenceConfig.PressureState.PressureConfig.Hi;
    return ValidateBottlePressure(newValue, HighPressureParam.BottlePressure, HighPressureParam.SourcePressure);
  };

  validateBottlePressureLow = (e) => {
    const {sequenceConfig} = this.state;
    // const id = e.type;
    const newValue = e.value;
    const LowPressureParam = sequenceConfig.PressureState.PressureConfig.Lo;
    return ValidateBottlePressure(newValue, LowPressureParam.SourcePressure, LowPressureParam.SourcePressure);
  };

  validateDiaphragmPressureHight = (e) => {
    const {sequenceConfig} = this.state;
    // const id = e.type;
    const newValue = e.value;
    const HighPressureParam = sequenceConfig.PressureState.PressureConfig.Hi;
    return ValidateDiaphragmPressure(newValue, HighPressureParam.DiaphragmPressure, HighPressureParam.SourcePressure);
  };

  validateDiaphragmPressureLow = (e) => {
    const {sequenceConfig} = this.state;
    // const id = e.type;
    const newValue = e.value;
    const LowPressureParam = sequenceConfig.PressureState.PressureConfig.Lo;
    return ValidateDiaphragmPressure(newValue, LowPressureParam.DiaphragmPressure, LowPressureParam.SourcePressure);
  };

  validateSourcePressureHight = (e) => {
    const {sequenceConfig, PressureControllerThreshold} = this.state;
    // const id = e.type;
    const newValue = e.value;
    const HighPressureParam = sequenceConfig.PressureState.PressureConfig.Hi;
    return ValidateSourcePressure(
      newValue,
      HighPressureParam.SourcePressure,
      HighPressureParam.BottlePressure,
      HighPressureParam.DiaphragmPressure,
      PressureControllerThreshold.length,
    );
  };

  validateSourcePressureLow = (e) => {
    const {sequenceConfig, PressureControllerThreshold} = this.state;
    // const id = e.type;
    const newValue = e.value;
    const LowPressureParam = sequenceConfig.PressureState.PressureConfig.Lo;
    return ValidateSourcePressure(
      newValue,
      LowPressureParam.SourcePressure,
      LowPressureParam.BottlePressure,
      LowPressureParam.DiaphragmPressure,
      PressureControllerThreshold.length,
    );
  };

  // onClick = (e) => {
  //   const props = {
  //     currentValue: 0,
  //     headerTitle: 'Default Numpad Input Title',
  //     minValue: 0,
  //     maxValue: 1000,
  //     callback: this.onChangeField,
  //     validatorInput: undefined,
  //     maxDigitAfterDecimal: APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
  //     info: undefined,
  //   };
  //   const minValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MIN_VALUE;
  //   const maxValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MAX_VALUE;
  //   const maxDigitAfterDecimal = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].DECIMAL_PLACE_ACCURACY;
  //   const info = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].INFO;
  //   props.minValue = minValue;
  //   props.maxValue = maxValue;
  //   props.maxDigitAfterDecimal = maxDigitAfterDecimal;
  //   props.info = info;
  //   switch (e.currentTarget.id) {
  //     case APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
  //       props.currentValue = e.currentTarget.value;
  //       props.headerTitle = e.currentTarget.id;
  //       // props.minValue = 100;
  //       // props.maxValue = 1000;
  //       break;
  //     case APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
  //       props.currentValue = e.currentTarget.value;
  //       props.headerTitle = e.currentTarget.id;
  //       // props.minValue = 100;
  //       // props.maxValue = 1000;
  //       break;
  //     case APPDATA.FIELD_NAME.VALVE_TIMING:
  //       props.currentValue = e.currentTarget.value;
  //       props.headerTitle = e.currentTarget.id;
  //       // props.minValue = 10;
  //       // props.maxValue = 1000;
  //       break;
  //     default:
  //       break;
  //   }
  //   consoleLog('Show Numpad', {ADVANCE_SETUP_RESTRICTION: ADVANCE_SETUP_RESTRICTION[e.currentTarget.id], props});
  //   this.showNumpad(props);
  // };

  showNumpad = (props) => {
    this.props.dispatch(
      modalActions.showModal({
        modalHeader: props.headerTitle,
        modalTitle: props.label === undefined ? null : props.label,
        value: props.currentValue,
        callback: props.callback,
        maxValue: props.maxValue,
        minValue: props.minValue,
        maxDigitAfterDecimal: props.maxDigitAfterDecimal,
        incrementValue: props.incrementValue,
        unit: props.unit,
        validatorInput: props.validatorInput,
        info: props.info,
      }),
    );
  };

  onChangeField = (e) => {
    const HightPrefix = 'High-';
    const LowPrefix = 'Low-';
    const HighPressureParam = PC_COMMON_FUNCTION.createNewJsonObject(
      this.state.sequenceConfig.PressureState.PressureConfig.Hi,
    );
    const LowPressureparam = PC_COMMON_FUNCTION.createNewJsonObject(
      this.state.sequenceConfig.PressureState.PressureConfig.Lo,
    );
    const value = parseFloat(e.value);
    let newSequenceConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);
    switch (e.type) {
      case HightPrefix + APPDATA.FIELD_NAME.SOURCE_PRESSURE:
        if (value < HighPressureParam[PRESSURE_ROW.DIAPHRAGM] + 10) {
          HighPressureParam[PRESSURE_ROW.DIAPHRAGM] = value - 10;
        }
        if (value < HighPressureParam[PRESSURE_ROW.BOTTLE]) {
          HighPressureParam[PRESSURE_ROW.BOTTLE] = value;
        }
        HighPressureParam[PRESSURE_ROW.SOURCE] = value;
        newSequenceConfig.PressureState.PressureConfig.Hi = HighPressureParam;
        break;
      case HightPrefix + APPDATA.FIELD_NAME.VACUUM_PRESSURE:
        HighPressureParam[PRESSURE_ROW.VACUUM] = value;
        newSequenceConfig.PressureState.PressureConfig.Hi = HighPressureParam;
        break;
      case HightPrefix + APPDATA.FIELD_NAME.BOTTLE_PRESSURE:
        HighPressureParam[PRESSURE_ROW.BOTTLE] = value;
        newSequenceConfig.PressureState.PressureConfig.Hi = HighPressureParam;
        break;
      case HightPrefix + APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE:
      case LowPrefix + APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE:
        LowPressureparam[PRESSURE_ROW.DIAPHRAGM] = value;
        newSequenceConfig.PressureState.PressureConfig.Lo = LowPressureparam;
        // break;
        HighPressureParam[PRESSURE_ROW.DIAPHRAGM] = value;
        newSequenceConfig.PressureState.PressureConfig.Hi = HighPressureParam;
        break;
      case HightPrefix + APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
      case LowPrefix + APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
        newSequenceConfig = UpdateDiaphragmTimingOpen(newSequenceConfig, value, PRESSURE_CONSTANT.PRESSURE_TYPE.LO);
        // break;
        newSequenceConfig = UpdateDiaphragmTimingOpen(newSequenceConfig, value, PRESSURE_CONSTANT.PRESSURE_TYPE.HI);
        break;
      case HightPrefix + APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
      case LowPrefix + APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
        newSequenceConfig = UpdateDiaphragmTimingClose(newSequenceConfig, value, PRESSURE_CONSTANT.PRESSURE_TYPE.LO);
        // break;
        newSequenceConfig = UpdateDiaphragmTimingClose(newSequenceConfig, value, PRESSURE_CONSTANT.PRESSURE_TYPE.HI);
        break;
      case HightPrefix + APPDATA.FIELD_NAME.VALVE_TIMING:
      case LowPrefix + APPDATA.FIELD_NAME.VALVE_TIMING:
        newSequenceConfig = UpdateValveTiming(newSequenceConfig, value, PRESSURE_CONSTANT.PRESSURE_TYPE.LO);
        // break;
        newSequenceConfig = UpdateValveTiming(newSequenceConfig, value, PRESSURE_CONSTANT.PRESSURE_TYPE.HI);
        break;
      case LowPrefix + APPDATA.FIELD_NAME.SOURCE_PRESSURE:
        if (value < LowPressureparam[PRESSURE_ROW.DIAPHRAGM] + 10) {
          LowPressureparam[PRESSURE_ROW.DIAPHRAGM] = value - 10;
        }
        if (value < LowPressureparam[PRESSURE_ROW.BOTTLE]) {
          LowPressureparam[PRESSURE_ROW.BOTTLE] = value;
        }
        LowPressureparam[PRESSURE_ROW.SOURCE] = value;
        newSequenceConfig.PressureState.PressureConfig.Lo = LowPressureparam;
        break;
      case LowPrefix + APPDATA.FIELD_NAME.VACUUM_PRESSURE:
        LowPressureparam[PRESSURE_ROW.VACUUM] = value;
        newSequenceConfig.PressureState.PressureConfig.Lo = LowPressureparam;
        break;
      case LowPrefix + APPDATA.FIELD_NAME.BOTTLE_PRESSURE:
        LowPressureparam[PRESSURE_ROW.BOTTLE] = value;
        newSequenceConfig.PressureState.PressureConfig.Lo = LowPressureparam;
        break;
      default:
        break;
    }
    this.updateSequenceConfig(newSequenceConfig);
  };

  changeViewMode = (selectedSequenceId) => {
    const viewProps = {
      viewMode: VIEW_MODE.DESIGNER,
      operationId: selectedSequenceId,
    };
    this.props.changeViewMode(viewProps);
  };

  saveConfig = () => {
    this.props.saveConfigProps(this.state.sequenceConfig.Id, this.state.sequenceConfig);
    this.changeViewMode({viewMode: VIEW_MODE.DESIGNER, operationId: this.state.sequenceConfig.Id});
  };

  discardConfig = () => {
    this.changeViewMode({viewMode: VIEW_MODE.DESIGNER, operationId: this.state.sequenceConfig.Id});
  };

  updateSequenceState = (selectedSequenceId, newValue) => {
    const newSequenceConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);
    newSequenceConfig.Active = newValue;
    this.updateSequenceConfig(newSequenceConfig);
  };

  updatePressureType = (selectedSequenceId, newValue) => {
    const newSequenceConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);
    newSequenceConfig.PressureState.PressureType = newValue;
    this.updateSequenceConfig(newSequenceConfig);
  };

  sequenceChange = (selectedSequenceId, oldSequenceType) => {
    const popUpButton = [
      {
        id: APPDATA.OK,
        isPrimaryButton: true,
        onClick: this.setChangeSequenceType,
        label: APPDATA.OK,
      },
    ];
    const sequenceSelector = GenerateSequenceSelector(
      SEQUENCE_TYPE,
      selectedSequenceId,
      oldSequenceType,
      this.onChangeSequenceType,
      'cycle-dropdown-selection',
    );
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: 'Select Cycle',
        popUpText: sequenceSelector,
        popUpButton,
      }),
    );
  };

  setChangeSequenceType = async () => {
    // const selectedSequenceId = this.state.sequenceConfig.Id;
    const newState = this._tempNewChangeOfSequence.newSequenceType;
    let newSequenceConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);
    // newSequenceConfig.Sequence = newState;
    newSequenceConfig = UpdateSequenceType(
      newSequenceConfig,
      newState,
      this.props.defaultConfigAdvSetupParams.ConfigAdvSetup,
    );
    newSequenceConfig = await UpdateTempRate(newSequenceConfig, newState);
    // newSequenceConfig.PressureState.PressureConfig = this.props.defaultSequenceTemplate.PressureState.PressureConfig;
    this.props.dispatch(modalActions.hidePopUp());
    this.updateSequenceConfig(newSequenceConfig);
  };

  onChangeSequenceType = (newSequenceType, selectedSequenceId, oldSequenceType) => {
    this._tempNewChangeOfSequence = {
      newSequenceType,
      selectedSequenceId,
      oldSequenceType,
    };
  };

  updateTotalRepeat = () => {
    const currentOperation = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);
    const maxValue = findMaxValueByRepeatType(currentOperation.RepeatType);
    const incrementValue = findIncrementValueByRepeatType(currentOperation.RepeatType);
    const maxDigitAfterDecimal = findMaxDigitValueByRepeatType(currentOperation.RepeatType);

    const props = {
      currentValue: currentOperation.TempRepeat,
      headerTitle:
        currentOperation.RepeatType === RUN_TIME_MODE.TIMES.VALUE
          ? RUN_TIME_MODE.TIMES.NAME
          : RUN_TIME_MODE.MINUTES.NAME,
      minValue: currentOperation.RepeatType === RUN_TIME_MODE.TIMES.VALUE ? 1 : 0.01,
      maxValue,
      callback: this.changeTotalRepeat,
      maxDigitAfterDecimal,
      incrementValue,
      unit: 'x',
    };
    this.showNumpad(props);
    // newSequenceConfig.TempRepeat = newValue
    // this.updateSequenceConfig(newSequenceConfig)
  };

  changeTotalRepeat = (e) => {
    const newValue = e.value;
    const newSequenceConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);

    newSequenceConfig.TempRepeat = newValue;
    this.updateSequenceConfig(newSequenceConfig);
  };

  onChangeRepeatMode = (selectedSequenceId, newValue) => {
    const newSequenceConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.sequenceConfig);
    newSequenceConfig.RepeatType = newValue;
    if (newValue === 1) {
      // const test = Math.round(newSequenceConfig.TempRepeat);

      newSequenceConfig.TempRepeat = Math.round(newSequenceConfig.TempRepeat);
    }
    this.setState({
      sequenceConfig: newSequenceConfig,
      parameterChanged: true,
    });
  };

  resetToDefault = () => {
    const defaultConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.props.defaultSequenceTemplate);
    defaultConfig.Id = this.state.sequenceConfig.Id;
    defaultConfig.Sequence = this.state.sequenceConfig.Sequence;
    const defaultConfigSetup = this.props.defaultConfigAdvSetupParams.ConfigAdvSetup;

    defaultConfig.TempRepeat = this.state.sequenceConfig.TempRepeat;
    defaultConfig.RepeatType = this.state.sequenceConfig.RepeatType;
    switch (this.state.sequenceConfig.Sequence) {
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.HI;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.MainAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.MainAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Hi.DiaphragmTimingOpen = defaultConfigSetup.MainAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Hi.DiaphragmTimingClose = defaultConfigSetup.MainAdvSetup.DiaphragmTimingClose;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.MainAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.MainAdvSetup.DiaphragmTimingClose;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.HI;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.DiafiltrationAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.DiafiltrationAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen =
          defaultConfigSetup.DiafiltrationAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose =
          defaultConfigSetup.DiafiltrationAdvSetup.DiaphragmTimingClose;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.RecoveryAdvSetup.DiaphragmTimingClose;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.RecoveryAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen =
          defaultConfigSetup.RecoveryAdvSetup.BufferRecoveryDiaphragmTiming.FillTiming;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose =
          defaultConfigSetup.RecoveryAdvSetup.BufferRecoveryDiaphragmTiming.EmptyTiming;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingClose;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.PrimeAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose = defaultConfigSetup.PrimeAdvSetup.DiaphragmTimingClose;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.TubeMixingAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.TubeMixingAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen = defaultConfigSetup.TubeMixingAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose =
          defaultConfigSetup.TubeMixingAdvSetup.DiaphragmTimingClose;
        break;
      case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE].value:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
        defaultConfig.PressureState.PressureConfig.Hi = defaultConfigSetup.RecirculateAdvSetup.PressureAdvSetup;
        defaultConfig.PressureState.PressureConfig.Lo = defaultConfigSetup.RecirculateAdvSetup.PressureAdvSetup;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingOpen =
          defaultConfigSetup.RecirculateAdvSetup.DiaphragmTimingOpen;
        defaultConfig.SequenceParams.Lo.DiaphragmTimingClose =
          defaultConfigSetup.RecirculateAdvSetup.DiaphragmTimingClose;
        break;
      default:
        defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
    }
    // if (
    //     this.state.sequenceConfig.Sequence === SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE].value ||
    //     this.state.sequenceConfig.Sequence === SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE].value
    // ) {
    //     defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.HI;
    // } else if (
    //     this.state.sequenceConfig.Sequence === SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].value ||
    //     this.state.sequenceConfig.Sequence === SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].value
    // ) {
    //     defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
    //     //defaultConfig.TempRepeat = 3;
    // } else if (this.state.sequenceConfig.Sequence === SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].value) {
    //     //defaultConfig.TempRepeat = 7;
    //     defaultConfig.PressureState.PressureType = PRESSURE_CONSTANT.PRESSURE_TYPE.LO;
    // }
    this.updateSequenceConfig(defaultConfig);
  };

  render() {
    // const {updateSequenceState,updatePressureType,sequenceChange,updateTotalRepeat} = this.props.methodCallback
    const {sequenceConfig} = this.state;
    const style = {
      constraint: {
        fontSize: this.props.fontSize,
        margin: 15,
      },
    };
    const HighPressureParam = sequenceConfig.PressureState.PressureConfig.Hi;
    const LowPressureparam = sequenceConfig.PressureState.PressureConfig.Lo;
    const enableHIPressure =
      sequenceConfig.Sequence === SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE ||
      sequenceConfig.Sequence === SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE ||
      sequenceConfig.Sequence === SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE;
    const enableHIPressureDiaphragmTime = sequenceConfig.Sequence === SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE;
    return (
      <div className="configurationParent">
        <CycleSetting
          sequence={sequenceConfig}
          isSequenceDesignerRunning={false}
          removeSequence={undefined}
          updateSequenceState={this.updateSequenceState}
          updatePressureType={this.updatePressureType}
          sequenceChange={this.sequenceChange}
          updateTotalRepeat={this.updateTotalRepeat}
          onClickSequenceConfig={undefined}
          onClickSaveConfig={this.saveConfig}
          onClickDiscardConfig={this.discardConfig}
          isConfigView
          onChangeRepeatMode={this.onChangeRepeatMode}
        />
        <div className="row row-margin presureText">
          <h3>
            <b className="presureText">{PRESSURE_CONSTANT.PRESSURE_LABEL}</b>
          </h3>
        </div>
        <div
          style={style.constraint}
          className="row center "
        >
          <div className="col-md-6">
            <InputField
              label={APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE}
              inputValue={
                enableHIPressure ? HighPressureParam[PRESSURE_ROW.DIAPHRAGM] : LowPressureparam[PRESSURE_ROW.DIAPHRAGM]
              }
              unit={APPDATA.UNIT.psi}
              onClick={enableHIPressure ? this.onClickHight : this.onClickLow}
              disabled={false}
            />
            <br />
            {sequenceConfig.Sequence === SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE && (
              <InputField
                label={APPDATA.FIELD_NAME.BOTTLE_PRESSURE}
                inputValue={
                  // eslint-disable-next-line no-nested-ternary
                  sequenceConfig.Sequence === SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE
                    ? 0
                    : enableHIPressure
                    ? HighPressureParam[PRESSURE_ROW.BOTTLE]
                    : LowPressureparam[PRESSURE_ROW.BOTTLE]
                }
                unit={APPDATA.UNIT.psi}
                onClick={enableHIPressure ? this.onClickHight : this.onClickLow}
                disabled={false}
              />
            )}
            <br />
          </div>
          <div className="col-md-6">
            <InputField
              label={APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME}
              inputValue={
                enableHIPressureDiaphragmTime
                  ? sequenceConfig.SequenceParams.Hi.DiaphragmTimingOpen
                  : sequenceConfig.SequenceParams.Lo.DiaphragmTimingOpen
              }
              unit={APPDATA.UNIT.ms}
              onClick={enableHIPressureDiaphragmTime ? this.onClickHight : this.onClickLow}
              disabled={false}
            />
            <br />
            <InputField
              label={APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME}
              inputValue={
                enableHIPressureDiaphragmTime
                  ? sequenceConfig.SequenceParams.Hi.DiaphragmTimingClose
                  : sequenceConfig.SequenceParams.Lo.DiaphragmTimingClose
              }
              unit={APPDATA.UNIT.ms}
              onClick={enableHIPressureDiaphragmTime ? this.onClickHight : this.onClickLow}
              disabled={false}
            />
            <br />
          </div>
        </div>
        <div className="row center fullHeight">
          <div className="col-md-2 center btnContainer">
            <button
              type="button"
              id={APPDATA.RESET.toUpperCase()}
              className="resetButton-secondary "
              onClick={this.resetToDefault}
              disabled={!this.state.parameterChanged}
            >
              {APPDATA.RESET.toUpperCase()}
            </button>
          </div>
          <div className="col-md-2 center btnContainer">
            <button
              type="button"
              id={APPDATA.SAVE}
              className="saveButton "
              onClick={this.saveConfig}
              disabled={false}
            >
              {APPDATA.SAVE}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default SequenceConfiguration;
